// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

export const XngPopulateApiParameter = (props: any) => {
    if (!props.cartToUpdate) {
        return;
    }

    props.apiParameter = {
        cart: {
            ...props.apiParameter.cart,
            properties: {
                ...props.cartToUpdate.properties,
                ReleaseNumber: props.parameter?.releaseNumber,
                PhoneNumber: props.parameter?.phoneNumber,
                associateName: props.parameter?.associateName,
                doNotShipBeforeDate: props.parameter?.doNotShipBeforeDate,
                shipComplete: props.parameter?.shipComplete,
            },
        },
    };
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
